import $ from "jquery";
import { KioskCheckInComponent } from "./kiosk-check-in-component";
import { createRoot } from "react-dom/client";
import React from "react";

interface KioskCheckInContainerConfig {
  $container: JQuery;
  onRegisterSelected: () => void;
  onRegisterCompleted: () => void;
}

class KioskCheckInContainer {
  private config: KioskCheckInContainerConfig;

  constructor(config: KioskCheckInContainerConfig) {
    this.config = config;
    this.initialize();
  }

  private initialize() {
    const offlineEventId = this.config.$container.data(
      "offline-event-id"
    ) as number;
    const offlineEventName = this.config.$container.data(
      "offline-event-name"
    ) as string;
    const submitButtonText = this.config.$container.data(
      "submit-button-text"
    ) as string;
    const container = this.config.$container[0];

    if (!container) {
      return;
    }

    const root = createRoot(container);
    root.render(
      <KioskCheckInComponent
        offlineEventId={offlineEventId}
        offlineEventName={offlineEventName}
        submitButtonText={submitButtonText}
        onRegisterSelected={() => this.config.onRegisterSelected()}
        onRegisterCompleted={() => this.config.onRegisterCompleted()}
        onRegistrationCanceled={() => this.config.onRegisterCompleted()}
      />
    );
  }
}

export default KioskCheckInContainer;
